export default class GForms {
  constructor(gform) {
    let dropdownContainer = gform.querySelectorAll('select')

    let svg = document.createElement('svg')
    let caret = svg.innerHTML = '<svg width="12" height="22" viewBox="0 0 12 22" xmlns="http://www.w3.org/2000/svg"><path d="M-1.144 3.357L2.052.144l7.845 7.804.051-.048 3.196 3.213-.034.032.034.03-3.196 3.212-.05-.045-7.846 7.802-3.196-3.214 7.83-7.785z" fill-rule="evenodd"/></svg>'

    // let svgCaret = svgElem.appendChild(caret)

    dropdownContainer.forEach(dropdown => {
      dropdown.parentNode.style.position = 'relative'
      dropdown.parentNode.style.maxWidth = '409px'
      dropdown.insertAdjacentHTML('afterend', caret)
    })
  }
}
